export const CANCEl_SUBSCRIPTION_DIALOG_KEY = 'CANCEl_SUBSCRIPTION_DIALOG_KEY'
export const REVISE_DElIVERY_DATE_DIALOG_KEY = 'REVISE_DElIVERY_DATE_DIALOG_KEY'
export const REVISE_DELIVERY_AMOUNT_DIALOG_KEY = 'REVISE_DELIVERY_AMOUNT_DIALOG_KEY'
export const SERVER_ERROR_DIALOG_KEY = 'SERVER_ERROR_DIALOG_KEY'
